import { render, staticRenderFns } from "./VimeoClip.vue?vue&type=template&id=334d7252&lang=pug&"
import script from "./VimeoClip.vue?vue&type=script&lang=js&"
export * from "./VimeoClip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports